import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/hooks/useFetch";
import { inr, fmtDate } from "@/lib/format";
import { ChangePassword } from "@/pages/admin/Settings";

export default function Profile() {
  const { salesman } = useAuth();
  const { data: rec } = useFetch(`/receivables/${salesman.id}`);
  const rows = [["Salesman ID", salesman.code], ["Full name", salesman.full_name], ["Mobile", salesman.mobile], ["Employee code", salesman.employee_code],
    ["Login ID", salesman.username], ["Joining date", fmtDate(salesman.joining_date)], ["Status", salesman.status]];
  return (
    <div className="space-y-5">
      <h1 className="text-2xl font-bold tracking-tight">Profile</h1>
      <div className="divide-y divide-slate-100 rounded-md border border-slate-200 bg-white" data-testid="profile-card">
        {rows.map(([l, v]) => <div key={l} className="flex justify-between px-4 py-2.5 text-sm"><span className="text-slate-500">{l}</span><span className="font-semibold">{v}</span></div>)}
      </div>
      <div className="rounded-md border border-red-200 bg-red-50/50 p-4" data-testid="profile-receivable">
        <p className="text-[11px] font-bold uppercase tracking-[0.15em] text-red-700">Amount due from me</p>
        <p className="mt-1 font-mono text-2xl font-bold text-red-700" data-testid="profile-outstanding">{inr(rec?.outstanding ?? 0)}</p>
        <p className="text-xs text-slate-600">Total due {inr(rec?.due ?? 0)} · Settled {inr(rec?.settled ?? 0)}</p>
        {(rec?.settlements || []).slice(0, 5).map((s) => <p key={s.id} className="mt-1 text-xs text-slate-600">Paid {inr(s.amount)} on {fmtDate(s.date)}</p>)}
      </div>
      <div className="rounded-md border border-slate-200 bg-white p-4"><p className="mb-3 text-sm font-bold">Change password</p><ChangePassword /></div>
    </div>
  );
}
